<template>
  <client-layout>
    <confirm-dialog
      v-model="isDeleteClientConfirmDialogOpened"
      text="Êtes-vous sûr de vouloir supprimer ce client ?"
      @yes="deleteClient()"
    />
    <div>
      <v-row no-gutters align="center" class="content-header">
        <span class="font-weight-bold">Infos générales</span>
        <v-spacer></v-spacer>
        <v-btn class="n-white-btn n-small-btn px-2 mr-2" v-if="false">
          <v-icon>menu</v-icon>
        </v-btn>
      </v-row>
      <div class="page-main-content">
        <n-card class="pa-6">
          <v-alert dense text outlined type="info" class="text-left" v-if="!canUpdateInfos">
            Ce client gère lui-même ces informations
          </v-alert>
          <v-row>
            <v-col cols="2">
              <v-text-field v-model="client.ref" label="Référence" outlined hide-details readonly :disabled="!canUpdateInfos" />
            </v-col>
            <v-col cols="10">
              <v-text-field v-model="client.name" label="Nom" outlined hide-details required :disabled="!canUpdateInfos" />
            </v-col>
          </v-row>
          <v-col align="right" class="pr-0 pt-6" v-if="canUpdateInfos">
            <v-btn
              dark
              color="primary"
              elevation="0"
              :disabled="!$canWrite || (isDeletingClient)"
              @click="$canWrite && (save($event))"
            >
              Enregistrer
            </v-btn>
          </v-col>
        </n-card>
        <n-card class="pa-6 mt-6" v-if="canUpdateInfos">
          <v-row no-gutters justify="start" align="center">
            <v-col class="pr-4">
              <div class="text-overline font-weight-bold text-left">Supprimer ce client</div>
              <div class="text-caption text-left">Vous ne verrez plus ses interventions et ses utilisateurs seront désactivés</div>
            </v-col>
            <!-- <v-spacer /> -->
            <v-btn
              :disabled="!$canWrite"
              color="error"
              outlined
              elevation="0"
              :loading="isDeletingClient"
              @click="$canWrite && (isDeleteClientConfirmDialogOpened = true)"
            >
              Supprimer ce client
            </v-btn>
          </v-row>
        </n-card>
      </div>
    </div>
  </client-layout>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import ClientLayout from '@/views/settings/clients/ClientLayout.vue';

export default {
  name: `SettingsClientInfos`,
  data: () => ({
    client: {},
    isDeleteClientConfirmDialogOpened: false,
    isDeletingClient: false,
  }),
  computed: {
    ...mapState(`model/client`, {
      storeCurrentAdminClient: state => _.cloneDeep(state.currentAdminClient),
    }),
    canUpdateInfos() {
      return this.client?.slug === ``;
    },
  },
  watch: {
    storeCurrentAdminClient(newValue) {
      this.client = newValue;
    },
  },
  beforeMount() {
    this.client = this.storeCurrentAdminClient || {};
  },
  methods: {
    async save() {
      await this.$store.dispatch(`model/client/saveClient`, { client: this.client });
      this.$store.dispatch(`showSnackbar`, {
        color: `success`,
        message: `Client modifié avec succès`,
      });
    },
    async deleteClient() {
      this.isDeletingClient = true;
      await this.$store.dispatch(`model/client/deleteClient`, this.client);
      this.$store.commit(`ui/clientsList/SET_KEEPING_PREVIOUS_STATE`, false);
      this.$router.push(`/settings/clients`);
      this.isDeletingClient = false;
    },
  },
  components: {
    ClientLayout,
  },
};
</script>

<style lang="scss">
</style>
